import React, { useEffect, useState } from "react";
import { Outlet, useNavigation } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollToTop from "../../helper/ScrollTop";
import Loading from "../../components/Loading";
import FloatIcon from "../../components/FloatIcon";

const RootLayout = () => {
  const [loading, setLoading] = useState(false);
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === "loading") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [navigation.state]);

  return (
    <div className="container">
      {/* {loading && <Loading />} */}
      <Header />
      <ScrollToTop />
      <Outlet />
      <FloatIcon />
      <Footer />
    </div>
  );
};

export default RootLayout;
